import React, { Component, MouseEvent } from 'react';
import b from 'b_';
import { Link } from 'react-router-dom';

import './breadcrumbs.css';

export interface BreadcrumbItem {
    text: string;
    url?: string;
    onClick?(event?: MouseEvent): void;
}

export interface Props {
    items: BreadcrumbItem[];
    hideHome?: boolean;
    cls?: string;
}

const class_ = b.with('breadcrumbs');

class Breadcrumbs extends Component<Props> {
    public shouldComponentUpdate() {
        return true;
    }

    public renderItem = ({ url, text, onClick }: BreadcrumbItem, index: number) => {
        if (!url) {
            return (<span key={text} className={class_('item')}>{text}</span>);
        }

        return (
            <li
                key={text}
                className={class_('item')}
                itemProp="itemListElement"
                itemScope
                itemType="http://schema.org/ListItem"
            >
                <Link
                    itemProp="item"
                    className={class_('item')}
                    to={url}
                    onClick={onClick}
                >
                    <span itemProp="name">{text}</span>
                </Link>
                <meta itemProp="position" content={String(index + 1)} />
            </li>
        );
    };

    public render() {
        const { items, cls = '', hideHome = false } = this.props;
        const defaultBreadcrumbs: BreadcrumbItem[] = hideHome ? [] : [{ text: 'Home', url: '/' }];
        const result = defaultBreadcrumbs.concat(items).filter(item => item.text);

        return (
            <ol className={`${class_()} ${cls}`} itemScope itemType="http://schema.org/BreadcrumbList">
                {result.map(this.renderItem)}
            </ol>
        );
    }
}

export default Breadcrumbs;
